<template>
    <div id="technologies" class="technologies">
        <div class="wrapper">
            <div class="technologies__content">
                <h2>TECHNOLOGIES</h2>
                <p class="centered-text">TreeTopTrip team loves JS-based technology stack and .NET platform with Azure. We also like fiddling with Java and AWS. We even can do some PHP-ing for you… if you insist. </p>
                <div class="technologies__content__logos">
                    <div class="technologies__content__logos__azure"
                        data-aos="fade-up"
                        data-aos-delay="50"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__aws"
                        data-aos="fade-up"
                        data-aos-delay="150"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__react"
                        data-aos="fade-up"
                        data-aos-delay="250"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__nodejs"
                        data-aos="fade-up"
                        data-aos-delay="350"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__dotnet"
                        data-aos="fade-up"
                        data-aos-delay="450"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__php"
                        data-aos="fade-up"
                        data-aos-delay="550"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                    <div class="technologies__content__logos__java"
                        data-aos="fade-up"
                        data-aos-delay="650"
                        data-aos-duration="1000"
                        data-aos-easing="ease-in-sine"
                        data-aos-once="true"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'technologies',
    }
</script>

<style lang="scss" scoped>
    .technologies {
        width: 100%;

        .wrapper {
            padding-top: 300px;
            padding-bottom: 300px;

        }

        &__content {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;

            h2 {
                position: relative;
                display: inline-block;
                color: #ff5400;
                font-weight: 600;
                font-size: 14px;
                margin-bottom: 80px;
                letter-spacing: 3px;

                &::after {
                    content: 'Technologies';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    color: rgba(102, 102, 102, 0.3);
                    font-size: 100px;
                    font-family: kazimir, sans-serif;
                    font-weight: 300;
                }
            }

            &__logos {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;
                margin-top: 100px;
                justify-content: space-evenly;

                & > * {
                    height: 80px;
                    width: 100px;
                    margin: 20px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: contain;
                }

                &__azure {
                    background-image: url("../assets/technologies/azure.png");
                }
                &__aws {
                    background-image: url("../assets/technologies/aws.png");
                }
                &__react {
                    background-image: url("../assets/technologies/react.png");
                }
                &__nodejs {
                    background-image: url("../assets/technologies/nodejs.png");
                }
                &__dotnet {
                    background-image: url("../assets/technologies/dotnet.png");
                }
                &__php {
                    background-image: url("../assets/technologies/php.svg");
                }
                &__java {
                    background-image: url("../assets/technologies/java.png");
                }
            }
        }
    }

    @media all and (max-width: 1200px) {
        .technologies {
            .wrapper {
                padding-top: 200px;
                padding-bottom: 200px;
            }
        }
    }

    @media all and (max-width: 970px) {
        .technologies {
            padding-top: 100px;
        }
    }
    
    @media all and (max-width: 830px) {
        .technologies {
            .wrapper {
                padding-top: 150px;
                padding-bottom: 150px;
            }

            &__content {

                h2 {
                    margin-bottom: 60px;
                    &::after {
                        font-size: 70px;
                    }
                }

                &__logos {
                    padding: 0 20px;
                    margin-top: 60px;

                    & > * {
                        height: 60px;
                        width: 80px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 530px) {
        .technologies {
            padding-top: 75px;

            .wrapper {
                padding-top: 100px;
                padding-bottom: 100px;
            }

            &__content {
                h2 {
                    margin-bottom: 40px;
                    font-size: 9px;

                    &::after {
                        font-size: 45px;
                    }
                }

                &__logos {
                    padding: 0 20px;

                    & > * {
                        margin: 15px;
                        height: 40px;
                        width: 60px;
                    }
                }
            }
        }
    }

    @media all and (max-width: 330px) {
        .technologies {
            &__content {
                h2 {
                    margin-bottom: 35px;
                    font-size: 7px;

                    &::after {
                        font-size: 35px;
                    }
                }
            }
        }
    }
</style>